!function(){"use strict";class t extends window.theme.DeferredMedia{constructor(){super()}loadContent(){super.loadContent(),Shopify.loadFeatures([{name:"model-viewer-ui",version:"1.0",onLoad:this.setupModelViewerUI.bind(this)}])}setupModelViewerUI(t){t||(this.modelViewerUI=new Shopify.ModelViewerUI(this.querySelector("model-viewer")))}}window.ProductModel={loadShopifyXR(){Shopify.loadFeatures([{name:"shopify-xr",version:"1.0",onLoad:this.setupShopifyXR.bind(this)}])},setupShopifyXR(t){t||(window.ShopifyXR?(document.querySelectorAll('[id^="ModelJSON-"]').forEach((t=>{window.ShopifyXR.addModels(JSON.parse(t.textContent)),t.remove()})),window.ShopifyXR.setupXRElements()):document.addEventListener("shopify_xr_initialized",(()=>this.setupShopifyXR())))}},window.addEventListener("DOMContentLoaded",(()=>{window.ProductModel&&window.ProductModel.loadShopifyXR()}));const e="[data-add-to-cart]",r="[data-product-json]",o="[data-product-form]",i="#cart-bar",s="[data-popup-open]",a=".product__submit__add",n="[data-form-wrapper]",d="[data-product-variants]",c="is-loading",l="is-visible",h="data-cart-bar-enabled",u="data-add-to-cart-bar",p="data-cart-bar-scroll",m="data-cart-bar-product-notification",f="data-sticky-enabled";customElements.get("product-component")||customElements.define("product-component",class extends HTMLElement{constructor(){super(),this.stickyEnabled="true"===this.getAttribute(f),this.formWrapper=this.querySelector(n),this.cartBarEnabled=this.hasAttribute(h),this.cartBar=this.querySelector(i),this.setCartBarHeight=this.setCartBarHeight.bind(this),this.scrollToTop=this.scrollToTop.bind(this),this.toggleCartBarOnScroll=this.toggleCartBarOnScroll.bind(this),this.unlockTimer=0}connectedCallback(){const t=this.querySelector(r);if(t&&!t.innerHTML||!t)return;const e=JSON.parse(t.innerHTML).handle;let i={};e&&(i={handle:e}),Shopify.Products.recordRecentlyViewed(i),Shopify.Products&&Shopify.Products.recordRecentlyViewed&&Shopify.Products.recordRecentlyViewed(i),this.form=this.querySelector(o),this.cartBarEnabled&&(this.initCartBar(),this.setCartBarHeight(),document.addEventListener("theme:scroll",this.toggleCartBarOnScroll),document.addEventListener("theme:resize",this.setCartBarHeight))}initCartBar(){this.cartBarBtns=this.cartBar.querySelectorAll(a),this.cartBarBtns.length>0&&this.cartBarBtns.forEach((t=>{t.addEventListener("click",(t=>{t.preventDefault(),t.currentTarget.hasAttribute(u)?(this.cartBarEnabled&&(t.currentTarget.classList.add(c),t.currentTarget.setAttribute("disabled","disabled")),this.form.querySelector(e).dispatchEvent(new Event("click",{bubbles:!0}))):t.currentTarget.hasAttribute(p)?this.scrollToTop():t.currentTarget.hasAttribute(m)&&this.form.querySelector(s)?.dispatchEvent(new Event("click"))})),t.hasAttribute(u)&&document.addEventListener("theme:product:add-error",this.scrollToTop)})),this.setCartBarHeight()}scrollToTop(){const t=this.querySelector(d),e=(window.theme.isMobile()?t||this.form:this).getBoundingClientRect().top;window.theme.scrollTo(window.theme.isMobile()?e-10:e)}toggleCartBarOnScroll(){const t=window.scrollY,e=theme.variables.productPageSticky&&this.formWrapper?this.formWrapper:this.form;if(e&&this.cartBar){const r=t>e.offsetTop+e.offsetHeight;this.cartBar.classList.toggle(l,r)}}setCartBarHeight(){const t=this.cartBar.offsetHeight;document.documentElement.style.setProperty("--cart-bar-height",`${t}px`)}disconnectedCallback(){document.removeEventListener("theme:product:add-error",this.scrollToTop),this.cartBarEnabled&&(document.removeEventListener("theme:scroll",this.toggleCartBarOnScroll),document.removeEventListener("theme:resize",this.setCartBarHeight))}}),customElements.get("product-model")||customElements.define("product-model",t)}();

(function() {
  /**
   * 📘 ARQUIA IMAGE FILTERING GUIDE:
   * ---------------------------------------------------------
   * 1. SINGLE COLOR: "Pink" 
   * -> Shows only when Pink is selected.
   * * 2. BUNDLE LOCK (AND): "Navy Blue, Light Blue with Navy Blue" 
   * -> Shows ONLY if BOTH variants are selected. Fixes color-bleed/conflicts.
   * * 3. MULTI-COLOR (OR): "Pink with Engine Red ; Engine Red with Pink" 
   * -> Shows if EITHER variant is selected. Use for sibling/lifestyle shots.
   * * 4. SEO: Use "|" to separate tags from description.
   * -> "Pink ; Red | High quality pima cotton"
   * ---------------------------------------------------------
   */
  const jsonTag = document.querySelector('[data-product-json]');
  const productTitle = (jsonTag) ? JSON.parse(jsonTag.innerHTML).title.toLowerCase().trim() : "";

  // Setup Hidden Bins
  const slideBin = document.createElement('div');
  const thumbBin = document.createElement('div');
  slideBin.style.display = 'none';
  thumbBin.style.display = 'none';
  document.body.appendChild(slideBin);
  document.body.appendChild(thumbBin);

  let slideContainer, thumbContainer;
  let allSlides = [], allThumbs = [];

  const initCache = () => {
    slideContainer = document.querySelector('.product__slides');
    thumbContainer = document.querySelector('.product__thumbs__holder');
    if (!slideContainer) return false;

    allSlides = Array.from(slideContainer.querySelectorAll('.product__slide'));
    allThumbs = thumbContainer ? Array.from(thumbContainer.querySelectorAll('.product__thumb')) : [];
    
    allSlides.forEach((s, i) => s.dataset.originalIndex = i);
    allThumbs.forEach((t, i) => t.dataset.originalIndex = i);
    return true;
  };

  const getActiveColors = () => {
    const colors = [];
    document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
      const fieldsetText = radio.closest('fieldset')?.innerText.toLowerCase() || '';
      if (radio.name.toLowerCase().includes('color') || fieldsetText.includes('color')) {
        colors.push(radio.value.toLowerCase().trim());
      }
    });
    return colors;
  };

  const rebuildGallery = (activeColors) => {
    if (!activeColors.length || !allSlides.length) return;
    
    const matchedSlides = [];
    const matchedThumbs = [];

    allSlides.forEach((slide, i) => {
      let rawAlt = slide.getAttribute('data-media-color') || slide.querySelector('img')?.alt || "";
      
      // 1. Isolate functional part before the pipe |
      const cleanAlt = rawAlt.split('|')[0].toLowerCase().trim();
      
      // 2. GLOBAL MATCH: Empty alt or matching product title
      if (cleanAlt === "" || cleanAlt === productTitle) {
        matchedSlides.push(slide);
        if (allThumbs[i]) matchedThumbs.push(allThumbs[i]);
        return;
      }

      // 3. HYBRID LOGIC: 
      // Semicolon (;) means OR. Comma (,) means AND.
      const orGroups = cleanAlt.split(';').map(g => g.trim());
      
      const isMatch = orGroups.some(group => {
        // For each semicolon-separated group, check for commas
        const andTags = group.split(',').map(t => t.trim()).filter(t => t !== "");

        if (andTags.length > 1) {
          return andTags.every(tag => {
            if (tag.startsWith('!')) {
              // Negation: this tag must NOT be active
              return !activeColors.includes(tag.slice(1).trim());
            }
            return activeColors.includes(tag);
          });
        } else {
          const tag = andTags[0];
          if (tag.startsWith('!')) return !activeColors.includes(tag.slice(1).trim());
          return activeColors.includes(tag);
        }

      });

      if (isMatch) {
        matchedSlides.push(slide);
        if (allThumbs[i]) matchedThumbs.push(allThumbs[i]);
      } else {
        slideBin.appendChild(slide);
        if (allThumbs[i]) thumbBin.appendChild(allThumbs[i]);
      }
    });

    // Re-insert matched nodes in their original order
    const sortFn = (a, b) => a.dataset.originalIndex - b.dataset.originalIndex;
    matchedSlides.sort(sortFn).forEach((s, idx) => {
      s.classList.remove('media--active', 'media--hidden');
      s.classList.add(idx === 0 ? 'media--active' : 'media--hidden');
      slideContainer.appendChild(s);
    });

    matchedThumbs.sort(sortFn).forEach((t, idx) => {
      t.classList.toggle('is-active', idx === 0);
      if (thumbContainer) thumbContainer.appendChild(t);
    });

    // Reset view and trigger theme resize
    slideContainer.scrollLeft = 0;
    window.dispatchEvent(new Event('resize'));
  };

  const init = () => {
    setTimeout(() => {
      if (initCache()) rebuildGallery(getActiveColors());
    }, 200);

    document.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"], select')) {
        // Delay to allow the external sync script to finish patching colors
        setTimeout(() => rebuildGallery(getActiveColors()), 120);
      }
    });
  };

  init();
})();